<div style="display: contents">
  <div class="spinner-container" *ngIf="!urlLoaded">
    <custom-loader></custom-loader>
  </div>

  <!-- {{urlSafe}} -->
  <iframe *ngIf="urlLoaded" width="100%" height="100%" frameborder="0" [src]="urlSafe"></iframe>
</div>
